export default __webpack_public_path__ + "static/The Home_Image 6_carousel 2@2x-08c31ab1da1ae57c3b423ec81a23bac0.jpg";